import React, { useEffect, useRef, useState } from 'react';
import { KeenIcon } from '@/components';
import { Modal, ModalContent, ModalBody, ModalHeader } from '@/components/modal';
import { useResponsive, useViewport } from '@/hooks';
import { Intro } from '@/pages/hettwer/offer/blocks/source/Intro';
import { UploadDocument } from '@/pages/hettwer/shared/new-soruce/UploadDocument';
import { OfferDetailsData } from '@/pages/hettwer/types/OfferDetailsData';
import { UploadTextWithDictation } from '@/pages/hettwer/shared/new-soruce/UploadTextWithDictation';

interface OfferModalProps {
  open: boolean;
  onClose: () => void;
  mode: 'create' | 'addSource';
  offer?: OfferDetailsData | null;
  refreshOfferData?: () => void;
}

const OfferModal: React.FC<OfferModalProps> = ({
  open,
  onClose,
  mode,
  offer = null,
  refreshOfferData
}) => {
  const isCreateMode = mode === 'create';
  const isAddSourceMode = mode === 'addSource';

  const desktopMode = useResponsive('up', 'lg');
  const navBar = useRef<any | null>(null);
  const parentRef = useRef<any | null>(null);
  const [sidebarHeight, setSidebarHeight] = useState<number>(0);
  const [viewportHeight] = useViewport();
  const offset = 260;

  useEffect(() => {
    setSidebarHeight(viewportHeight - offset);
  }, [viewportHeight]);

  const getTitle = (): string => {
    if (isCreateMode) {
      return 'Neues Angebot anlegen';
    }
    if (isAddSourceMode && offer) {
      return `Neue Quelle zum Angebot ${offer.offer_number ?? ''} hinzufügen`;
    }
    return 'Angebot';
  };

  /**
   * ⚠️ WICHTIG:
   * Entity.name MUSS ein string sein
   * offer.offer_number ist optional → sauber absichern
   */
  const entity = offer
    ? {
        p_id: offer.p_id,
        name: offer.offer_number ?? 'Angebot'
      }
    : null;

  return (
    <Modal open={open} onClose={onClose} className="!flex">
      <ModalContent className="container-fixed px-30 overflow-hidden pt-7.5 my-[3%] w-full">
        <ModalHeader className="p-0 border-0">
          <div className="flex items-center justify-between flex-wrap grow gap-5 pb-7.5">
            <div className="flex items-baseline space-x-2">
              <KeenIcon icon="home" className="text-3xl" />
              <h1 className="text-xl font-semibold leading-none text-gray-900">{getTitle()}</h1>
            </div>
            <div className="flex items-center gap-3">
              <button className="btn btn-sm btn-light" onClick={onClose}>
                Schließen
              </button>
            </div>
          </div>
        </ModalHeader>

        <ModalBody className="scrollable-y py-0 mb-5 ps-0 pe-3 -me-5.5" ref={parentRef}>
          <div className="flex grow gap-5 lg:gap-7.5">
            <div className="flex flex-col items-stretch grow gap-5 lg:gap-7.5">
              <Intro mode={mode} />

              <UploadTextWithDictation
                parentEntity={entity}
                objectEntity={entity}
                entityType="new_offer"
                mode={mode}
                onSuccess={refreshOfferData}
              />

              <UploadDocument
                parentEntity={entity}
                objectEntity={entity}
                entityType="existing_offer"
                mode={mode}
                onSuccess={refreshOfferData}
              />
            </div>
          </div>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export { OfferModal };
